import { CopyPlugin } from '@jollywise/jollygoodgame/src/components/copy/CopyPlugin';

export class CopyPuginTT extends CopyPlugin {
  constructor(...args) {
    super(...args);
    this.locale = 'en';
  }
  addCopyFromJSON(json) {
    this._copy = json;
  }
  setLocale(value) {
    this.locale = value;
  }
  get(copyId) {
    if (!this._copy[copyId]) {
      console.warn('copy not found [ ' + copyId + ' ]');
      return '';
    } else {
      return this._copy[copyId][this.locale] || '';
    }
  }
}
